/**
 * Enum denoting direction of travel while navigating via arrow keyboard keys
 */
export var KeyNavDir;
(function (KeyNavDir) {
    KeyNavDir["both"] = "both";
    KeyNavDir["grid"] = "grid";
    KeyNavDir["gridLinear"] = "grid-linear";
    KeyNavDir["vertical"] = "vertical";
    KeyNavDir["horizontal"] = "horizontal";
})(KeyNavDir || (KeyNavDir = {}));
//# sourceMappingURL=FlexPanel.types.js.map